<template>
  <div class="case-label-editor" ref="editorRef">
    <div class="empty-content" v-if="tableList.length < 1 && !listLoading">
      <img :src="emptyImg" alt="" class="empty-img" />
      <div class="empty-text">该搜索条件不存在案件</div>
    </div>

    <el-card v-for="(row, rowIndex) in tableList" :key="row.caseId" class="card-item" :ref="`case_${row.caseId}`">
      <div slot="header">
        <div class="case-header">
          <div class="check-tool" v-show="mulitCheckShow">
            <el-checkbox :value="mulitCheckArr.includes(row.caseId)" @change="$emit('updMulitCase', row.caseId)" />
          </div>
          <div class="case-title">
            <div class="case-number single-ellipsis">
              <span v-if="row.base_title">{{ row.base_title }}</span>
              <span v-else>{{ row.base_caseNumber }}</span>
            </div>
          </div>
          <div class="case-header-tools">
            <div
              class="tool-btn"
              @click="$emit('allParagraphShowHandle', row.caseId)"
              v-show="justShowHighText || selectParagraphArr.length > 0"
            >
              <div v-show="!allParagraphShow.includes(row.caseId)">
                <i class="iconfont iconchakanquanwen-xian"></i>
                <span>查看全段落</span>
              </div>
              <div v-show="allParagraphShow.includes(row.caseId)">
                <i class="iconfont iconchakanquanwen-mian active-icon"></i>
                <span>已查看全段落</span>
              </div>
            </div>
            <template v-if="!isRecommendMode && !resetDelShow">
              <div class="tool-btn" @click="$emit('collect', row)">
                <template v-if="row.isCollect">
                  <i class="iconfont iconshoucang-mian collect-icon"></i>
                  <span>已收藏</span>
                </template>
                <template v-else>
                  <i class="iconfont iconshoucang"></i>
                  <span>收藏</span>
                </template>
              </div>
              <div class="tool-btn" @click="delCaseHandle(row)">
                <i class="iconfont iconshanchu"></i>
                <span>删除</span>
              </div>
            </template>
          </div>
        </div>
        <div class="case-tag-ul">
          <template v-for="caseTagItem in caseTagArr">
            <div class="case-tag-item" :key="caseTagItem.field_name" v-if="row[caseTagItem.field_name]">
              <span>{{ row[caseTagItem.field_name] }}</span>
            </div>
          </template>
        </div>
      </div>
      <div class="empty-content" v-show="contentHeightArr[rowIndex] === 0">
        <template v-if="justShowHighText">
          <span>暂无高亮的句子</span>
        </template>
        <template v-else-if="selectParagraphArr.length > 0">
          <span>本案件因无</span>
          <span>“{{ selectParagraphArr | paragraphTipText(paragraphArr) }}”</span>
          <span>段落，无法显示文中内容</span>
        </template>
        <template v-else>
          <span>本案件暂无内容</span>
        </template>
      </div>
      <div
        class="text-container"
        :ref="`textContainer_${row.caseId}`"
        :class="!articleShow && !expandShowArr[row.caseId] && expandExistArr[rowIndex] ? 'hide-more' : ''"
      >
        <template v-for="(item, index) in tableTextArr[rowIndex].textArr">
          <div :key="index" class="text-content" v-if="showByParagraphFilter(item, row)">
            <div :style="item.isTitle ? {} : { 'text-indent': '2em' }">
              <template v-if="item.isTitle">
                <div
                  class="paragraph-title"
                  v-show="
                    showTitleByPeriod({ row, item, index, textArr: tableTextArr[rowIndex].textArr, justShowHighText })
                  "
                >
                  <span>{{ item.titleText }}</span>
                </div>
              </template>
              <template v-else v-for="(subItem, subIndex) in item.tagArr">
                <tag-text
                  v-if="subItem.isTag"
                  :key="subItem.textId"
                  :text="subItem.text"
                  :sign="`${row.caseId}/${item.paragraphKey}/${index}/${subIndex}`"
                  :tagItem="subItem"
                  :could-close="!resetDelShow"
                  tagSortShow
                  @close="delTagHandle({ rowIndex, columnKey: subItem.columnKey, entityId: subItem.id })"
                />
                <template v-else-if="subItem.isHigh">
                  <tag-text
                    v-if="subItem.recommendFieldDetail"
                    :key="subItem.textId"
                    :text="subItem.text"
                    :sign="`${row.caseId}/${item.paragraphKey}/${index}/${subIndex}`"
                    :tagItem="subItem.recommendFieldDetail"
                  />
                  <span v-else :key="subItem.textId" class="search-text-high">
                    <span :data-sign="`${row.caseId}/${item.paragraphKey}/${index}/${subIndex}`">{{
                      subItem.text
                    }}</span>
                  </span>
                </template>
                <template v-else>
                  <span :key="subItem.textId" v-show="showByPeriod({ row, subItem, justShowHighText })">
                    <span :data-sign="`${row.caseId}/${item.paragraphKey}/${index}/${subIndex}`">{{
                      subItem.text
                    }}</span>
                  </span>
                </template>
              </template>
            </div>
          </div>
        </template>
        <div class="expand-btn" v-show="!articleShow && expandExistArr[rowIndex]">
          <span
            v-show="expandShowArr[row.caseId]"
            @click="(expandShowArr[row.caseId] = false), changeScrollHandle(row.caseId)"
          >
            <span>收起</span>
            <i class="el-icon-arrow-up"></i>
          </span>
          <span v-show="!expandShowArr[row.caseId]" @click="expandShowArr[row.caseId] = true">
            <span>查看更多</span>
            <i class="el-icon-arrow-down"></i>
          </span>
        </div>
      </div>

      <tagRelationList
        v-if="!isRecommendMode"
        :row="row"
        :resetDelShow="resetDelShow"
        @changeFieldVal="info => changeFieldValHandle(info, rowIndex)"
        @tapAction="params => tapActionHandle(params, rowIndex)"
        @delTag="
          entityDetail =>
            delTagHandle({
              rowIndex,
              columnKey: entityDetail.fieldDetail.columnKey,
              entityId: entityDetail.dataInfo.id
            })
        "
      />
    </el-card>

    <slot name="custom-footer"></slot>

    <div class="popover-content" :style="popoverContentStyle">
      <el-popover
        ref="popoverRef"
        placement="bottom"
        :width="popoverWidth"
        trigger="click"
        @show="popoverShow = true"
        @hide="popoverShow = false"
      >
        <template v-if="popoverShow">
          <tag-field-picker
            v-if="modalShowMode === 'normal'"
            :pickRuleModal="pickRuleModal"
            :popoverLoading="popoverLoading"
            @createField="params => $emit('createField', params)"
            @close="$refs.popoverRef.doClose()"
            @confirm="addTagHandle"
          />
          <updTagRelationEditor
            v-if="modalShowMode === 'relation'"
            :confirmLoading="popoverLoading"
            :caseDetail="updRelationInfo.caseDetail"
            :entityDetail="updRelationInfo.entityDetail"
            @close="$refs.popoverRef.doClose()"
            @confirm="updTagRelationHandle"
          />
          <div v-if="modalShowMode === 'addTextAsk'" class="add-text-robot-container">
            <div class="add-text-robot-tip">是否添加划词原文？</div>
            <div class="add-text-robot-footer">
              <el-button size="mini" @click="addTextHandle(false)">
                <span>取消</span>
              </el-button>
              <el-button size="mini" type="primary" @click="addTextHandle(true)">
                <span>确定</span>
              </el-button>
            </div>
          </div>
        </template>
      </el-popover>
    </div>
  </div>
</template>

<script>
import TagText from './tagText';
import tagRelationList from './caseTagRelaionEditor/tagRelationList.vue';
import tagFieldPicker from './tagFieldPicker';
import updTagRelationEditor from './caseTagRelaionEditor/updTagRelationEditor.vue';

import { debounce, groupBy } from 'lodash';
import {
  fetchExistsTagPositionArr,
  fetchTextArr,
  formatPeriodHandle,
  formatSpecialSymbol,
  highTextBySearch,
  fetchParagraphIndex,
  fetchTagTextIndex,
  fetchNextTagItem,
  fetchSentence
} from './lib/labelCalculator';
import { delEmptyRegexp } from '@/constant';
import { computed } from 'vue';

import { services } from '@/service';
import emptyImg from '@/assets/img/缺省页.png';

export default {
  components: { TagText, tagRelationList, tagFieldPicker, updTagRelationEditor },
  data() {
    return {
      emptyImg,
      modalShowMode: '',
      pickRuleModal: {
        fields: [],
        defaultFieldDetail: null,
        isEmptyOffset: false,
        eventInfo: null,
        caseDetail: null
      },
      updRelationInfo: {
        rowIndex: -1,
        caseDetail: null,
        entityDetail: null
      },
      popoverContentStyle: { top: 0, left: 0 },
      currentScrollId: '',
      expandShowArr: {},
      contentHeightArr: [],
      popoverWidth: 280,
      popoverShow: false,
      popoverLoading: false,
      paragraphArr: [],
      addTextForRobot: null
    };
  },
  provide() {
    return {
      fieldsGroupByGroupRelationId: computed(() => groupBy(this.highLightFields, 'groupRelationId')),
      fieldsGroupByFieldName: computed(() => {
        const obj = {};
        this.highLightFields.forEach(fieldDetail => {
          obj[fieldDetail.field_name] = fieldDetail;
        });
        return obj;
      })
    };
  },
  props: {
    courseId: {
      type: String,
      default: ''
    },
    instrumentType: {
      type: String,
      default: ''
    },
    tableList: {
      type: Array,
      required: true
    },
    fields: {
      type: Array,
      required: true
    },
    highLightFields: {
      type: Array,
      required: true
    },
    searchOfParagraph: {
      type: Array,
      default: () => []
    },
    taskQueueIds: {
      type: Array,
      default: () => []
    },
    scrollId: {
      type: String,
      default: ''
    },
    selectParagraphArr: {
      type: Array,
      default: () => []
    },
    justShowHighText: {
      type: Boolean,
      default: false
    },
    allParagraphShow: {
      type: Array,
      default: () => []
    },
    articleShow: {
      type: Boolean,
      default: false
    },
    caseTagArr: {
      type: Array,
      default: () => []
    },
    listLoading: {
      type: Boolean,
      default: false
    },
    recommendValue: {
      type: Object,
      default: () => null
    },
    isRecommendMode: {
      type: Boolean,
      default: false
    },
    resetDelShow: {
      type: Boolean,
      default: false
    },
    mulitCheckShow: {
      type: Boolean,
      default: false
    },
    mulitCheckArr: {
      type: Array,
      default: () => []
    }
  },
  filters: {
    paragraphTipText(arr, paragraphArr) {
      let titleArr = arr
        .map(paragraphItem => {
          return paragraphArr.find(subItem => subItem.key === paragraphItem.key).value;
        })
        .filter(title => !!title);
      if (titleArr.length === 0) {
        return '';
      }
      titleArr = [...new Set(titleArr)];
      return titleArr.join('/');
    }
  },
  watch: {
    scrollId(val) {
      if (val !== this.currentScrollId) {
        this.changeScrollHandle(val);
      }
    },
    tableList: {
      handler() {
        const preExpandShowArr = { ...this.expandShowArr };
        const expandShowArr = {};
        this.tableList.forEach(item => {
          expandShowArr[item.caseId] = preExpandShowArr[item.caseId] || false;
        });
        this.expandShowArr = expandShowArr;
        this.$nextTick(() => {
          this.formatExpandExistHandle();
        });
      },
      immediate: true
    },
    selectParagraphArr: {
      handler() {
        this.$nextTick(() => {
          this.formatExpandExistHandle();
        });
      },
      deep: true
    },
    justShowHighText() {
      this.$nextTick(() => {
        this.formatExpandExistHandle();
      });
    },
    articleShow() {
      this.$nextTick(() => {
        this.formatExpandExistHandle();
      });
    },
    allParagraphShow() {
      this.$nextTick(() => {
        this.formatExpandExistHandle();
      });
    }
  },
  computed: {
    isAdmin() {
      return !!this.$store.getters.isAdmin;
    },
    tableTextArr() {
      return formatSpecialSymbol(
        // 格式化特殊符号显示
        this.initTableTextArr({
          // 格式化段落及高亮
          tableList: this.tableList,
          currentRuleArr: this.isRecommendMode ? [] : this.highLightFields
        })
      );
    },
    expandExistArr() {
      const tableList = [...this.tableList];
      return this.contentHeightArr.map((height, index) => {
        const item = tableList[index];
        if (!item) {
          return true;
        }
        if (this.allParagraphShow.includes(item.caseId)) {
          return false;
        }
        return height >= 600 * window.browserZoom;
      });
    }
  },
  beforeDestroy() {
    window.document.removeEventListener('mouseup', this.addTagHandleFunc);
    this.$refs.editorRef.removeEventListener('scroll', this.scrollTopWatcher);
  },
  created() {
    this.scrollTopWatcher = debounce(this.scrollTopWatcher.bind(this), 200);
    this.formatExpandExistHandle = debounce(this.formatExpandExistHandle.bind(this), 200);
  },
  async mounted() {
    window.document.addEventListener('mouseup', this.addTagHandleFunc);
    this.$refs.editorRef.addEventListener('scroll', this.scrollTopWatcher);
    const paragraphArr = await services.labelRelation.getParagraph(this.courseId);
    this.paragraphArr = paragraphArr;
  },
  methods: {
    addTextHandle(add = false) {
      this.$refs.popoverRef.doClose();
      window.getSelection().removeAllRanges();
      add && this.addTextForRobot();
    },
    formatExpandExistHandle() {
      const contentHeightArr = [];
      this.tableList.forEach(item => {
        const el = this.$refs[`textContainer_${item.caseId}`];
        const clientHeight = (el && el[0] && el[0].clientHeight) || 0;
        contentHeightArr.push(clientHeight);
      });
      this.contentHeightArr = contentHeightArr;
    },
    // 按显示段落筛选显示
    showByParagraphFilter(item, row) {
      if (this.allParagraphShow.includes(row.caseId)) {
        return true;
      }
      if (this.selectParagraphArr.length < 1) {
        return true;
      }
      const paragraphTitles = this.selectParagraphArr.map(paragraphItem => paragraphItem.value);
      return paragraphTitles.includes(item.paragraphTitle);
    },
    // 只显示高亮的句子，如果该标题下的内容有高亮则显示该标题
    showTitleByPeriod(params) {
      const { row, justShowHighText, index, item, textArr } = params;
      if (!justShowHighText) {
        return true;
      }
      if (this.allParagraphShow.includes(row.caseId)) {
        return true;
      }
      const currentParagraphTagArr = [];

      let i = index + 1;
      while (i < textArr.length) {
        const textItem = textArr[i];
        if (textItem.paragraphKey === item.paragraphKey) {
          currentParagraphTagArr.push(...(textItem.tagArr || []));
        } else {
          break;
        }
        i++;
      }
      return currentParagraphTagArr.some(textItem => {
        return textItem.isTag || textItem.isHigh;
      });
    },
    // 只显示高亮的句子
    showByPeriod(params) {
      const { row, justShowHighText, subItem } = params;
      if (!justShowHighText) {
        return true;
      }
      if (this.allParagraphShow.includes(row.caseId)) {
        return true;
      }
      if (subItem.isTag || subItem.isHigh || subItem.splitByHigh) {
        return true;
      }
      return false;
    },
    fetchTapPosition(e) {
      let parentNode = e.target;
      while (parentNode) {
        if (parentNode.className === 'popover-content') {
          return true;
        }
        if ((parentNode.className || '').includes('tag-popover-tooltip')) {
          return true;
        }
        if ((parentNode.className || '').includes('el-select-dropdown__item')) {
          return true;
        }
        parentNode = parentNode.parentNode;
      }
      return false;
    },
    addTagHandleFunc(e) {
      const isClickPopover = this.fetchTapPosition(e);
      if (!isClickPopover) {
        this.$refs.popoverRef.doClose();
      }

      const { button } = e;
      const selection = window.document.getSelection();
      const { isCollapsed, anchorNode, focusNode, anchorOffset, focusOffset } = selection;

      if (isCollapsed || button !== 0) {
        return;
      }

      // 获取dataset
      const anchorSign = anchorNode.parentNode.dataset.sign || '';
      const focusSign = focusNode.parentNode.dataset.sign || '';
      const anchorSignArr = anchorSign.split('/');
      const focusSignArr = focusSign.split('/');

      if (anchorSignArr.length !== 4 || focusSignArr.length !== 4) {
        return;
      }

      let [anchorRowId, anchorParagraphKey, anchorParagraphsIndex, anchorTagIndex] = anchorSignArr;
      let [focusRowId, focusParagraphKey, focusParagraphsIndex, focusTagIndex] = focusSignArr;
      const selectionStr = selection.toString().replace(/(\n\d+\n)|(\n\d+)|(^\d+\n)/g, '');

      if (!selectionStr || selectionStr.includes('。')) {
        return;
      }

      anchorParagraphsIndex = Number(anchorParagraphsIndex);
      focusParagraphsIndex = Number(focusParagraphsIndex);
      anchorTagIndex = Number(anchorTagIndex);
      focusTagIndex = Number(focusTagIndex);
      if (
        anchorRowId !== focusRowId ||
        anchorParagraphKey !== focusParagraphKey ||
        anchorParagraphsIndex !== focusParagraphsIndex
      ) {
        return;
      }

      if (this.$store.state.fieldEditorShow) {
        if (this.$refs.popoverRef.showPopper) {
          return;
        }
        if (this.$store.state.setSelectionFn) {
          this.addTextForRobot = () => this.$store.state.setSelectionFn(selectionStr, focusParagraphKey);
          this.initPopoverContentStyle(e);
          this.$nextTick(() => {
            this.modalShowMode = 'addTextAsk';
            this.$refs.popoverRef.doShow();
          });
        }
        return;
      }

      if (this.popoverShow || this.isRecommendMode || this.resetDelShow) {
        return;
      }

      const rowIndex = this.tableList.findIndex(item => item.caseId === anchorRowId);
      if (rowIndex < 0) {
        return;
      }

      const textRowItem = this.tableTextArr[rowIndex];
      const paraSentence = fetchSentence(textRowItem.textArr[anchorParagraphsIndex].tagArr, anchorTagIndex);

      const eventInfo = {
        rowIndex,
        anchorOffset,
        focusOffset,
        selectionStr,
        anchorRowId,
        focusRowId,
        anchorParagraphKey,
        focusParagraphKey,
        anchorParagraphsIndex,
        focusParagraphsIndex,
        anchorTagIndex,
        focusTagIndex,
        paraSentence
      };

      const fields = this.fields.filter(ruleItem => {
        if (this.taskQueueIds.includes(ruleItem.columnKey)) {
          return false;
        }
        return !ruleItem.isCalculator;
      });

      this.initPopoverContentStyle(e);
      this.$nextTick(() => {
        if (this.$refs.popoverRef.showPopper) {
          return;
        }
        this.$refs.popoverRef.doShow();
      });

      this.pickRuleModal = { fields, eventInfo, caseDetail: this.tableList[rowIndex] };
      this.modalShowMode = 'normal';
    },
    initPopoverContentStyle(e) {
      const editorRefPosition = this.$refs.editorRef.getBoundingClientRect();
      const top = e.y - editorRefPosition.top + this.$refs.editorRef.scrollTop + 20;
      let left = e.x - editorRefPosition.left;

      const outsideX = e.x + this.popoverWidth + 40 - editorRefPosition.right;
      if (outsideX > 0) {
        left -= outsideX;
      }

      this.popoverContentStyle = { top: `${top}px`, left: `${left}px` };
    },
    fetchEntitieHandle({ eventInfo, rule, dictVal = '' }) {
      const {
        anchorOffset,
        focusOffset,
        selectionStr,
        anchorParagraphKey,
        anchorParagraphsIndex,
        anchorTagIndex,
        focusTagIndex,
        rowIndex,
        paraSentence
      } = eventInfo;

      const { textArr, formatRangeArr } = this.tableTextArr[rowIndex];
      const { tagArr } = textArr[anchorParagraphsIndex];

      // 获取前面的tag-text[index]
      let startPreIndex = anchorTagIndex;
      if (focusTagIndex < startPreIndex) {
        startPreIndex = focusTagIndex;
      }

      // 获取前面的tag-text[startOffset]
      let startOffset = -1;
      if (anchorTagIndex === focusTagIndex) {
        startOffset = anchorOffset;
        if (focusOffset < anchorOffset) {
          startOffset = focusOffset;
        }
      } else if (focusTagIndex < anchorTagIndex) {
        startOffset = focusOffset;
      } else {
        startOffset = anchorOffset;
      }

      const startItem = tagArr[startPreIndex];
      let offset = startItem.start + startOffset;
      let selectionStrLen = selectionStr.length;

      formatRangeArr.forEach(rangeItem => {
        if (rangeItem.offset >= startItem.start && rangeItem.offset < offset + selectionStrLen) {
          if (offset <= rangeItem.offset) {
            selectionStrLen += rangeItem.originText.length - 1;
          } else {
            offset += rangeItem.originText.length - 1;
          }
        }
      });

      return {
        content: selectionStr,
        label: dictVal ? dictVal : rule.title,
        labelId: rule.columnKey,
        length: selectionStrLen,
        offset,
        para_type: anchorParagraphKey || null,
        para_sentence: paraSentence || null,
        coursewareId: this.courseId
      };
    },
    async addTagHandle({ eventInfo, rule, dictVal = '', relationParams, isEmptyOffset = false }) {
      try {
        this.popoverLoading = true;

        const { rowIndex } = eventInfo;
        const rowItem = this.tableList[rowIndex];
        let entity = {};
        if (isEmptyOffset) {
          entity = this.fetchEmptyEntite({ rule, dictVal });
        } else {
          entity = this.fetchEntitieHandle({ eventInfo, rule, dictVal });
        }

        const labelInfo = {
          ...relationParams,
          entity
        };

        this.$emit('addCaseLabel', {
          rowIndex,
          callback: () => {
            const isHighLightField = this.highLightFields.findIndex(o => o._id === rule._id) > -1;
            if (!isHighLightField) {
              this.$message.success('标注成功，请切换右侧至[全部]或将标签[恢复显示]后查看标注高亮');
            }
            this.popoverLoading = false;
            this.$refs.popoverRef.doClose();
          },
          rowDetail: rowItem,
          labelInfo
        });
      } catch (err) {
        this.popoverLoading = false;
        this.$refs.popoverRef.doClose();
        this.$error(err);
      }
    },
    async updTagRelationHandle(body) {
      try {
        this.popoverLoading = true;

        this.$emit('updCaseLabelRelation', {
          rowIndex: this.updRelationInfo.rowIndex,
          rowDetail: this.updRelationInfo.caseDetail,
          queryBody: body,
          callback: () => {
            this.popoverLoading = false;
            this.$refs.popoverRef.doClose();
          }
        });
      } catch (err) {
        this.popoverLoading = false;
        this.$refs.popoverRef.doClose();
        this.$error(err);
      }
    },
    delTagHandle({ rowIndex, columnKey, entityId }) {
      if (this.taskQueueIds.includes(columnKey)) {
        this.$message.warning('该标签正在自动标注，请稍候再试');
        return;
      }
      this.$emit('delCaseLabel', {
        ruleKey: columnKey,
        rowIndex,
        tipMsg: '删除标注中...',
        rowDetail: this.tableList[rowIndex],
        labelDetailArr: [entityId],
        callback: res => {
          if (res && res.pass) {
            this.$message.success('标注清除成功');
          }
        }
      });
    },
    async changeFieldValHandle(info, rowIndex) {
      const { val, entityDetail } = info;
      const { fieldDetail, dataInfo } = entityDetail;
      const rowItem = this.tableList[rowIndex];
      const { columnKey } = fieldDetail;
      const labelInfo = { id: dataInfo.id, valueInfo: {} };
      if (fieldDetail.type === 'date') {
        labelInfo.valueInfo.timestamp = val;
      }
      if (fieldDetail.type === 'num') {
        labelInfo.valueInfo.value = val;
      }
      this.$emit('updCaseLabel', {
        ruleKey: columnKey,
        rowIndex,
        tipMsg: '标签值修改中...',
        rowDetail: rowItem,
        labelInfo,
        callback: res => {
          if (res && res.pass) {
            this.$message.success('标签值修改成功');
          }
        }
      });
    },
    tapActionHandle(params, rowIndex) {
      const { action, info } = params;
      const { nodePosition, fieldDetail } = info;

      if (action === 'updRelation') {
        this.updRelationInfo = {
          rowIndex,
          caseDetail: this.tableList[rowIndex],
          entityDetail: info.entityDetail
        };
        this.modalShowMode = 'relation';
      }

      if (action === 'addEmptyEntity') {
        this.pickRuleModal = {
          fields: info.fields,
          defaultFieldDetail: fieldDetail,
          isEmptyOffset: true,
          eventInfo: { rowIndex, selectionStr: '', paraSentence: '' },
          caseDetail: this.tableList[rowIndex]
        };
        this.modalShowMode = 'normal';
      }

      this.initPopoverContentStyle(nodePosition);
      this.$nextTick(() => {
        if (this.$refs.popoverRef.showPopper) {
          return;
        }
        this.$refs.popoverRef.doShow();
      });
    },
    fetchEmptyEntite({ rule, dictVal }) {
      return {
        content: '',
        label: dictVal ? dictVal : rule.title,
        labelId: rule.columnKey,
        length: 0,
        offset: 0,
        para_type: null,
        para_sentence: null,
        coursewareId: this.courseId
      };
    },
    initTableTextArr(params) {
      const { tableList, currentRuleArr } = params;
      const paragraphTitleEnum = {};
      const paragraphTitleEnumFilter = {};
      this.paragraphArr.forEach(paragraphItem => {
        let isEffParagraph = false;
        if (typeof paragraphItem.groups === 'string') {
          isEffParagraph = paragraphItem.groups === this.instrumentType;
        } else {
          try {
            isEffParagraph = (paragraphItem.groups || []).includes(this.instrumentType);
          } catch (err) {
            // ...
          }
        }
        if (isEffParagraph) {
          paragraphTitleEnumFilter[paragraphItem.value] = paragraphItem;
        }
        paragraphTitleEnum[paragraphItem.key] = paragraphItem.value;
      });
      return tableList.map(item => {
        // 获取有效的标注
        const tagPositionArr = fetchExistsTagPositionArr({
          currentRuleArr,
          rowDetail: item
        });

        // 获取段落及段落内容
        let textArr = fetchTextArr({ rowDetail: item, paragraphTitleEnumFilter });

        // 按句号分割
        textArr = formatPeriodHandle(textArr);

        // 根据tag的start位置和每段的长度判断在哪行
        tagPositionArr.forEach(tagPositionItem => {
          if (tagPositionItem.start >= tagPositionItem.end) {
            return;
          }

          // 根据标注位置获取所在的段落index
          const currentParagraphIndex = fetchParagraphIndex({ textArr, tagPositionItem });

          // true代表标注文本跨段落
          if (currentParagraphIndex < 0) {
            return;
          }

          const { tagArr } = textArr[currentParagraphIndex];

          // 获取段落内文本span的index
          let currentTagTextIndex = fetchTagTextIndex({ tagArr, tagPositionItem });

          if (currentTagTextIndex < 0) {
            return;
          }

          let currentItem = tagArr[currentTagTextIndex];

          // 如果需要在已有tag-text内渲染则需要从下一个span-text开始渲染，并记录该tag原始的start
          if (currentItem.isTag) {
            const newTagIndex = fetchNextTagItem({ currentTagTextIndex, tagArr });

            if (newTagIndex === -1) {
              return;
            }

            currentTagTextIndex = newTagIndex;
            currentItem = tagArr[newTagIndex];
            tagPositionItem.start = currentItem.start;

            if (tagPositionItem.start >= tagPositionItem.end) {
              return;
            }
          }

          const currentItemText = currentItem.text;
          const sameStart = tagPositionItem.start === currentItem.start;
          const haveNextItem = tagPositionItem.end < currentItem.start + currentItem.text.length;
          let nextIndex = -1;

          let tagItemText = '';

          // 将tag-span塞进去，判断前后文本怎么处理
          if (sameStart) {
            tagItemText = currentItemText.slice(0, tagPositionItem.end - tagPositionItem.start);
            tagArr.splice(currentTagTextIndex, 1, {
              id: tagPositionItem.id,
              textId: `${tagPositionItem.start}_${tagItemText.length}`,
              isTag: true,
              text: tagItemText,
              start: tagPositionItem.start,
              columnKey: tagPositionItem.columnKey,
              columnTitle: tagPositionItem.columnTitle,
              columnFullName: tagPositionItem.columnFullName,
              fieldThemeName: tagPositionItem.fieldThemeName,
              fieldIndex: tagPositionItem.fieldIndex
            });
            nextIndex = currentTagTextIndex + 1;
          } else {
            currentItem.text = currentItemText.slice(0, tagPositionItem.start - currentItem.start);
            currentItem.textId = `${currentItem.start}_${currentItem.text.length}`;
            currentItem.splitByHigh = true;
            tagItemText = currentItemText.slice(
              tagPositionItem.start - currentItem.start,
              tagPositionItem.end - currentItem.start
            );
            tagArr.splice(currentTagTextIndex + 1, 0, {
              id: tagPositionItem.id,
              textId: `${tagPositionItem.start}_${tagItemText.length}`,
              isTag: true,
              text: tagItemText,
              start: tagPositionItem.start,
              columnKey: tagPositionItem.columnKey,
              columnTitle: tagPositionItem.columnTitle,
              columnFullName: tagPositionItem.columnFullName,
              fieldThemeName: tagPositionItem.fieldThemeName,
              fieldIndex: tagPositionItem.fieldIndex
            });
            nextIndex = currentTagTextIndex + 2;
          }
          if (haveNextItem && nextIndex > -1) {
            const nextItemText = currentItemText.slice(tagPositionItem.end - currentItem.start);
            tagArr.splice(nextIndex, 0, {
              textId: `${tagPositionItem.start + tagItemText.length}_${nextItemText.length}`,
              isTag: false,
              text: nextItemText,
              start: tagPositionItem.start + tagItemText.length,
              splitByHigh: true
            });
          }
        });

        const { paragraph = [], content = [], recommendFieldDetail } = this.recommendValue || {};
        if (paragraph.length > 0 && content.length > 0) {
          content.forEach(recommendWord => {
            textArr = highTextBySearch(textArr, { text: recommendWord, selects: paragraph }, paragraphTitleEnum, {
              recommendFieldDetail
            });
          });
        }

        const searchOfParagraph = this.formatParagraphArr(this.searchOfParagraph);
        searchOfParagraph.forEach(paragraphItem => {
          textArr = highTextBySearch(textArr, paragraphItem.info, paragraphTitleEnum);
        });

        return textArr;
      });
    },
    formatParagraphArr(searchOfParagraph) {
      const newArr = [];
      searchOfParagraph.forEach(paragraphDetail => {
        let { text } = paragraphDetail.info;
        text = text.replace(delEmptyRegexp, '');
        text = text.replace(/[ |*]+/g, '+');
        text = text.replace(/(-.*?\+)|(-.*?$)/g, (str = '') => {
          if (str.slice(-1) === '+') {
            return '+';
          }
          return '';
        });
        let searchTextList = text.split('+').filter(text => !!text);
        searchTextList = [...new Set(searchTextList)];
        searchTextList.forEach(textTemp => {
          newArr.push({ ...paragraphDetail, info: { ...paragraphDetail.info, text: textTemp } });
        });
      });
      return newArr.filter(item => !!item.info.text);
    },
    async delCaseHandle(item) {
      await this.$confirm(`是否删除该案件?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      });
      this.$emit('delCase', item);
    },
    changeScrollHandle(id) {
      if (!id) {
        return '';
      }
      const caseEl = this.$refs[`case_${id}`][0];
      this.$refs.editorRef.scrollTop = caseEl.$el.offsetTop - 10;
    },
    scrollTopWatcher(event) {
      const scrollTop = event.target.scrollTop + 10 / window.browserZoom;
      let scrollId = '';
      for (let i = 0; i < this.tableList.length; i++) {
        const item = this.tableList[i];
        const caseEl = this.$refs[`case_${item.caseId}`][0];
        if (scrollTop >= caseEl.$el.offsetTop) {
          scrollId = item.caseId;
        } else {
          break;
        }
      }
      this.currentScrollId = scrollId;
      this.$emit('update:scrollId', scrollId);
    }
  }
};
</script>

<style lang="scss" scoped>
.add-text-robot-container {
  padding: 12px;

  .add-text-robot-tip {
    font-size: 14px;
    color: #3d465a;
  }

  .add-text-robot-footer {
    text-align: right;
    margin-top: 10px;
  }
}
.popover-content {
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  overflow: visible;
  z-index: 10;
}
.case-label-editor {
  position: relative;
  box-sizing: border-box;
  height: 100%;
  overflow-y: auto;
  padding: 10px 30px;

  .empty-content {
    margin: 50px 0 30px;
    text-align: center;

    .empty-img {
      width: 150px;
    }
    .empty-text {
      font-size: 14px;
      color: rgba(#3d465a, 0.4);
      margin-top: 10px;
    }
  }

  .card-item {
    margin-bottom: 20px;

    ::v-deep {
      .el-card__body {
        padding: 10px 0 0;
      }
      .el-card__header {
        position: relative;
        padding: 16px 20px;
      }
    }

    &:last-child {
      margin-bottom: 0;
    }

    .case-header {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .check-tool {
        margin-right: 10px;
      }
      .case-title {
        line-height: 30px;
        flex: 1;
        width: 0;

        .case-number {
          color: #2c3443;
          font-size: 14px;
        }
        .case-baseinfo {
          color: rgba(#a0acc0, 0.8);
          font-size: 12px;
          margin-top: 8px;
        }
      }

      .case-header-tools {
        position: relative;
        top: 10px;
        margin-right: -13px;
        display: flex;
        align-items: center;
        justify-content: flex-end;

        .tool-btn {
          padding: 5px 3px;
          cursor: pointer;
          margin-left: 10px;
          font-size: 12px;
          color: #9599a5;

          .iconfont {
            font-size: 12px;
            margin-right: 3px;

            &.active-icon {
              color: #1991fb;
            }

            &.collect-icon {
              color: #ffca1b;
            }
          }
        }
      }
    }

    .case-tag-ul {
      position: absolute;
      top: 0;
      right: 0;

      .case-tag-item {
        display: inline-block;
        height: 22px;
        line-height: 22px;
        font-size: 12px;
        color: #fff;
        background-color: #a0acc0;
        margin-right: 10px;
        padding: 0 10px;
      }
    }

    .empty-content {
      color: #9599a5;
      font-size: 14px;
      text-align: center;
      padding: 20px 0 30px;
    }

    .tool-content {
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 2px 0 10px;

      .tool-btn {
        padding: 5px 3px;
        cursor: pointer;
        margin-left: 10px;
        font-size: 12px;
        color: #9599a5;

        .iconfont {
          font-size: 12px;
          margin-right: 3px;

          &.active-icon {
            color: #1991fb;
          }

          &.collect-icon {
            color: #ffca1b;
          }
        }
      }
    }

    .text-container {
      position: relative;
      overflow: hidden;
      padding: 10px 20px 0;

      .expand-btn {
        text-align: center;
        font-size: 14px;
        color: #0d7de0;
        height: 50px;
        line-height: 65px;
        background: linear-gradient(0deg, #fff 48%, transparent);
        padding-top: 5px;

        & > span {
          padding: 0 10px;
          cursor: pointer;
        }
      }

      &.hide-more {
        max-height: 600px;

        .expand-btn {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
        }
      }

      .text-content {
        font-size: 14px;
        line-height: 24px;
        white-space: break-spaces;

        .search-text-high {
          background-color: #ee813b;
          color: #fff;
        }
        .paragraph-title {
          position: relative;
          font-size: 14px;
          margin: 20px 0 4px;
          padding-left: 8px;

          &::before {
            content: ' ';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 55%;
            border-radius: 30px;
            background-color: #0d7de0;
          }

          & > span {
            font-weight: 600;
          }
        }
        &:first-child {
          .paragraph-title {
            margin-top: 0;
          }
        }
      }
    }

    .fields-content {
    }
  }
}
</style>
